<script lang="ts">export let type = null;
export let message = '';
</script>

{#if type}
    <div class="alert alert-{type}" role="alert">{message}</div>
{:else}
    <div class="alert" role="alert">{message}</div>
{/if}
